<template>
    <textarea
        ref="textarea"
        class="w-full form-input form-input-bordered py-2"
        rows="1"
        :placeholder="$t('Enter text')"
        :value="item.response"
        @change="handleInput"
        @keyup="handleInput"
    />
</template>

<script>

    export default {

        components: {},

        props: {
            item: {
                type: Object,
                required: true,
            },
        },

        methods: {
            handleInput(event) {
                this.$store.commit('conduct/changeResponse', {
                    item: this.item.uuid,
                    response: event.target.value,
                    responded: event.target.value.length > 0,
                });
            },
        },

    };
</script>
